import React, { memo } from 'react'
import PropTypes from 'prop-types'
import DropdownPopover from '../DropdownPopover'
import DropdownItem from '../DropdownItem'
import NavLink from '../NavLink'
import { headerLinkShape } from '../../utils/shapes'

function NavDropdown ({
  className,
  label,
  target,
  iconName,
  color,
  backgroundColor,
  links
}) {
  const dropdownContent = (
    <DropdownContent links={links} target={target} color={color} />
  )

  return (
    links &&
    links.length > 0 && (
      <DropdownPopover
        id={`nav-dropdown-popover-${label}`}
        className={className}
        backgroundColor={backgroundColor}
        content={dropdownContent}
      >
        <NavLink
          label={label}
          iconName={iconName}
          dropdownIconName='ChevronDown'
          color={color}
        />
      </DropdownPopover>
    )
  )
}

function DropdownContent ({ links, target, color }) {
  return links.map(link => (
    <DropdownItem
      key={link.label}
      {...link}
      color={color}
      onClick={() =>
        window.open(link.href, target === '_blank' ? target : '_self')
      }
    />
  ))
}

NavDropdown.displayName = 'NavDropdown'

NavDropdown.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  target: PropTypes.string,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  links: PropTypes.arrayOf(headerLinkShape).isRequired
}

NavDropdown.defaultProps = {
  className: ''
}

export default memo(NavDropdown)
